import DOMPurify from "dompurify";

const ADMIN_IMAGE_BASE = "https://admin.fmexcon.com/public/images/";
const ADMIN_STORAGE_BASE = "https://admin.fmexcon.com/public/storage/images/";

/**
 * Sanitize HTML from API before rendering with dangerouslySetInnerHTML.
 */
export function sanitizeHtml(dirty) {
  if (!dirty || typeof dirty !== "string") return "";
  return DOMPurify.sanitize(dirty, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ["script", "iframe", "object", "embed", "form", "input"],
    FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover", "onfocus"],
  });
}

/**
 * Allow only a safe filename (no path traversal).
 */
export function safeFileName(name) {
  if (!name || typeof name !== "string") return "";
  const base = name.split(/[/\\]/).pop() || "";
  if (!base || base.includes("..") || /[<>"']/.test(base)) return "";
  return base;
}

/**
 * Build a safe admin image URL from API-provided filename.
 */
export function safeAdminImageUrl(imageName, { storage = false } = {}) {
  const file = safeFileName(imageName);
  if (!file) return "";
  return `${storage ? ADMIN_STORAGE_BASE : ADMIN_IMAGE_BASE}${encodeURIComponent(
    file
  ).replace(/%2F/gi, "")}`;
}

/**
 * Allow only http(s) external links from API (blocks javascript:, data:, etc).
 */
export function safeExternalUrl(url) {
  if (!url || typeof url !== "string") return "#";
  const trimmed = url.trim();
  if (trimmed === "#" || trimmed === "") return "#";
  try {
    const parsed = new URL(trimmed, window.location.origin);
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
      return "#";
    }
    return parsed.href;
  } catch {
    return "#";
  }
}

/**
 * Validate UUID-like tokens used in badge/certificate links.
 */
export function safeUuid(uuid) {
  if (!uuid || typeof uuid !== "string") return "";
  const cleaned = uuid.trim();
  if (!/^[A-Za-z0-9_-]{6,64}$/.test(cleaned)) return "";
  return cleaned;
}

/**
 * Validate route/API id params.
 */
export function safeId(id) {
  if (id == null) return "";
  const value = String(id);
  if (!/^[A-Za-z0-9_-]{1,64}$/.test(value)) return "";
  return value;
}
